import { softwareIcons } from '@acp/core-ui/assets';
import {
    Box,
    Button,
    Divider,
    HStack,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    useDisclosure,
    VStack,
} from '@chakra-ui/react';

export function GetProperlyModal({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) {
    return (
        <Modal
            isOpen={isOpen}
            autoFocus={false}
            onClose={onClose}
            size="2xl"
            trapFocus={false}
        >
            <ModalOverlay />
            <ModalContent pb={4} pt={2}>
                <ModalHeader pb={0}>Get Properly on iOS or Android</ModalHeader>
                <ModalBody>
                    <Tabs
                        isLazy
                        w="100%"
                        variant="underline"
                        colorScheme="primary"
                        fontSize="md"
                    >
                        <TabList w="100%" gap={[0, null, 6]}>
                            <Tab>iOS</Tab>
                            <Tab>Android</Tab>
                        </TabList>
                        <Divider borderColor="muted.100" />

                        <TabPanels pt={6}>
                            <TabPanel as={VStack} alignItems="start" p={0} pt={2} gap={4}>
                                <Text>
                                    Install Properly from the App Store on your iPhone
                                </Text>
                                <Text fontWeight="bold">
                                    Scan the QR code below using your camera to be taken
                                    to the Properly app on the App Store.
                                </Text>

                                <Box alignSelf="center">
                                    <Image
                                        src={softwareIcons.qrCodeProperlyIos}
                                        alt="QR Code to download Properly app"
                                        maxW={['200px', '200px']}
                                        maxH={['200px', '200px']}
                                        w="auto"
                                        h="auto"
                                        borderRadius="md"
                                        border="2px"
                                    />
                                </Box>

                                <Divider mb={2} />
                                <HStack justifyContent="space-between" w="full">
                                    <Button as="a" target="_blank" href="https://apps.apple.com/us/app/properly/id6748495141" colorScheme="secondary">
                                        Download on the App Store
                                    </Button>

                                    <Button variant="ghost" colorScheme="muted" onClick={() => onClose()}>
                                        Close
                                    </Button>
                                </HStack>
                            </TabPanel>
                            <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4}>
                                <Text>
                                    Install Properly from the
                                    Google Play Store on your Android device
                                </Text>
                                <Text fontWeight="bold">
                                    Scan the QR code below using your camera to be taken
                                    to the Properly app on the Google Play Store.
                                </Text>

                                <Box alignSelf="center">
                                    <Image
                                        src={softwareIcons.qrCodeProperlyAndroid}
                                        alt="QR Code to download Properly app"
                                        maxW={['200px', '200px']}
                                        maxH={['200px', '200px']}
                                        w="auto"
                                        h="auto"
                                        borderRadius="md"
                                        border="2px"
                                    />
                                </Box>
                                <Divider mb={2} />
                                <HStack justifyContent="space-between" w="full">
                                    <Button as="a" target="_blank" href="https://play.google.com/store/apps/details?id=au.com.detectorinspector.properly" colorScheme="secondary">
                                        Get it on Google Play
                                    </Button>

                                    <Button variant="ghost" colorScheme="muted" onClick={() => onClose()}>
                                        Close
                                    </Button>
                                </HStack>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export function GetProperlyButton(props: React.ComponentProps<typeof Button>) {
    const disclosure = useDisclosure();

    return (
        <>
            <Button {...props} onClick={() => disclosure.onOpen()} />
            <GetProperlyModal
                isOpen={disclosure.isOpen}
                onClose={disclosure.onClose}
            />
        </>
    );
}
